<frodo-confirmation-prompt
  [title]="'common.handedOff.confirmation' | translate : { orderId: clientCode }"
  [header]="'common.handedOff.confirmPromptTitle' | translate"
  [isLoading]="isLoading"
  [showHeader]="true"
  [confirmLabel]="'common.handedOff.confirmButton' | translate"
  [cancelLabel]="'common.handedOff.cancelButton' | translate"
  (confirm)="onConfirm()"
  (cancel)="redirectBack()"
  (back)="redirectBack()"
></frodo-confirmation-prompt>
